import UnavailableLocationModalContentContainer from './UnavailableLocationModalContentContainer';

export default UnavailableLocationModalContentContainer;
